module.exports = __webpack_public_path__ + "fonts/inter-latin-300-normal.woff2";